import { useQuery } from "@tanstack/react-query";
import { ENDPOINTS } from "@/api/application-api";
import { authHeader } from "@/utils/headers";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { PromptBlueprint } from "@/types";
import { useParams } from "react-router-dom";

type XRayPromptBlueprintResponse = {
  success: boolean;
  prompt_blueprint: PromptBlueprint;
  expanded: boolean;
};

const useXRayPromptBlueprint = (
  blueprint: PromptBlueprint,
  enabled: boolean = true,
) => {
  const { workspaceId } = useParams();
  const userToken = useAuth()?.userToken;

  return useQuery<XRayPromptBlueprintResponse>({
    queryKey: ["xray-prompt-blueprint", workspaceId, blueprint],
    queryFn: async () => {
      try {
        const response = await fetch(
          `${ENDPOINTS.expand_prompt_blueprint(Number(workspaceId!))}`,
          {
            method: "POST",
            headers: {
              ...authHeader(userToken!),
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ prompt_blueprint: blueprint }),
          },
        );
        return handleResponse(response);
      } catch (error) {
        throw error;
      }
    },
    enabled,
    retry: false,
  });
};

export default useXRayPromptBlueprint;
